module.exports = __webpack_public_path__ + "img/bottom.3befcf58.svg";